export const CHANGE_FREQUENCY = 'CHANGE_FREQUENCY';

export const changeFrequency = frequency => ({ type: CHANGE_FREQUENCY, payload: frequency });
